<head>
  <link rel="preconnect" href="https://fonts.googleapis.com">
  <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
  <link href="https://fonts.googleapis.com/css2?family=Gabarito:wght@600&family=Roboto:wght@700&display=swap" rel="stylesheet">
</head>
<section [ngClass]="badFeedback ? 'customerAppreciationPage' : 'customerAppreciationPage thankYou'">
  <header class="mob">
    @if (currentStep === 'preview') {
      <button class="backBtn" (click)="onBackClick()"><span class="arrow"></span></button>
    }
    <div class="pbLogoMob">
      <a href="https://www.policybazaar.com/" target="_blank" rel="noopener noreferrer">
      <img  width="32" height="32" src="../../../assets/images/pb-logo-mob.png" alt="pb logo"/></a>
    </div>
  </header>

  <div id="leftPanel" [ngClass]="(!showRight && isMobileView ? 'h-90vh ' : '') + (badFeedback ? 'leftPanel blue' : 'leftPanel green')">
    <div class="pbLogo">
      <a href="https://www.policybazaar.com/" target="_blank" rel="noopener noreferrer">
      <img  width="195" height="51" src="../../../assets/images/pb-white-logo.png" alt="pb logo"/></a>
    </div>

    <div class="title secondaryFont">
      {{textDisplay}}
    </div>

    @if (badFeedback) {
      <div class="infographic">
        <img src="../../../assets/images/infographic.png" alt="infographic" width="350" height="360"/>
      </div>
    }

    @if (!badFeedback) {
      <div class="infographic type2">
        <img class="left" src="../../../assets/images/thumbsUpLeft.svg"/>
        <img class="right" src="../../../assets/images/thumbsUpRight.svg"/>
      </div>
    }

    <div class="bg2">
      <img width="314" height="311" src="./../../../assets/images/star.svg" alt="star"/>
    </div>
  </div>

  @if (showRight) {
    <div class="rightPanel">
      <div class="formWrapper">
        <div class="formTitle">
          @if (currentStep === 'preview') {
            <button class="backBtn" (click)="goBack()"><span class="arrow"></span></button>
          }
          {{feedbackText}}
        </div>
        @if (badFeedback) {
          <div>
            @for (reason of reasons; track trackByIndex(i, reason); let i = $index) {
              <div class="formGroup">
                <label class="customRadioBtn">
                  <input type="checkbox" (change)="selectReason($event, reason, i)"/>
                  <div class="radioBox">
                    <span class="square"></span>
                    <span class="text">{{reason}}</span>
                  </div>
                </label>
              </div>
            }
            <div class="formGroup">
              <textarea cols="50" class="formControl" rows="3" placeholder="Tell us more…" [formControl]="commentControl"></textarea>
            </div>
            <button type="submit" [ngClass]="'primaryBtn ' + (!selectionControl.value.length ? 'disabled' : 'blue')" [disabled]="!selectionControl.value.length" (click)="initFeedbackSubmit()">Submit</button>
          </div>
        }
        @if (!badFeedback) {
          <div>
            <!-- Compose Step -->
            @if (currentStep === 'compose') {
              <div class="formGroup">
                <textarea cols="50" class="formControl" rows="15" [placeholder]="feedbackTextPlaceholder" [formControl]="commentControl"></textarea>
              </div>
              <div class="socialMediaShare">
                <span class="text">Share on</span>
                <div class="socialIcons">
                  <!-- Twitter/X: id = '3' -->
                  <a class="socialShareIcon" [class.disabledIcon]="!shareValid" (click)="openPreview($event,'3')">
                    <img width="32" height="32" src="../../../assets/images/twt.svg" alt="twt"/>
                  </a>
                  <!-- LinkedIn: id = '1' -->
                  <a class="socialShareIcon" [class.disabledIcon]="!shareValid" (click)="openPreview($event,'1')">
                    <img width="32" height="32" src="../../../assets/images/lkdn.svg" alt="linkedin"/>
                  </a>
                </div>
              </div>
            }
            <!-- Preview Step -->
            @if (currentStep === 'preview') {
              <div class="formGroup">
                <textarea cols="50" class="formControl" rows="15" [formControl]="previewFeedbackControl"></textarea>
              </div>
              <button type="button" class="primaryBtn green postBtn" (click)="postFromPreview()">Post</button>
            }
          </div>
        }
      </div>
    </div>
  }
</section>